import { z } from 'zod';

export const TaxonomyIndustrySchema = z.object({
  displayValue: z.string(),
});
export type TaxonomyIndustry = z.infer<typeof TaxonomyIndustrySchema>;

export const TaxonomyLegalTechSkillCategorySchema = z.object({
  displayName: z.string(),
});
export type TaxonomyLegalTechSkillCategory = z.infer<
  typeof TaxonomyLegalTechSkillCategorySchema
>;

export const TaxonomyLegalTechSkillSchema = z.object({
  displayName: z.string(),
  legalTechSkillCategory: z.string(),
});
export type TaxonomyLegalTechSkill = z.infer<
  typeof TaxonomyLegalTechSkillSchema
>;

export const TaxonomyGeneralSkillSchema = z.object({
  displayName: z.string(),
});
export type TaxonomyGeneralSkill = z.infer<typeof TaxonomyGeneralSkillSchema>;

export const TaxonomyLegalSkillSchema = z.object({
  skillGroup: z.string(),
  talentName: z.string(),
  alpEligible: z.boolean(),
  fullName: z.string(),
  shortName: z.string(),
});
export type TaxonomyLegalSkill = z.infer<typeof TaxonomyLegalSkillSchema>;

export const TaxonomyPracticeAreaSchema = z.object({
  fullName: z.string(),
  talentName: z.string(),
  shortName: z.string(),
  alpEligible: z.boolean(),
  selectable: z.boolean(),
});
export type TaxonomyPracticeArea = z.infer<typeof TaxonomyPracticeAreaSchema>;

export const TaxonomyFocusAreaSchema = z.object({
  alpEligible: z.boolean(),
  fullName: z.string(),
  practiceArea: z.string(),
  shortName: z.string(),
  standaloneDisplayName: z.string(),
  talentName: z.string(),
  selectable: z.boolean(),
});
export type TaxonomyFocusArea = z.infer<typeof TaxonomyFocusAreaSchema>;

export const TaxonomySkillGroupSchema = z.object({
  clientQuestion: z.string(),
  fullName: z.string(),
  talentQuestion: z.string(),
  focusArea: z.string(),
  alpEligible: z.boolean(),
});
export type TaxonomySkillGroup = z.infer<typeof TaxonomySkillGroupSchema>;

export const TaxonomyClientSubNavigationHeaderSchema = z.object({
  title: z.string(),
  practiceArea: z.string().optional(),
  businessTitle: z.string().optional(),
  keyword: z.string().optional(),
});
export type TaxonomyClientSubNavigationHeader = z.infer<
  typeof TaxonomyClientSubNavigationHeaderSchema
>;

export const TaxonomyBusinessTitleSchema = z.object({
  displayName: z.string(),
  jobProfile: z.string(),
});

export type TaxonomyBusinessTitle = z.infer<typeof TaxonomyBusinessTitleSchema>;

export const TaxonomyJobProfileSchema = z.object({
  displayName: z.string(),
});
export type TaxonomyJobProfile = z.infer<typeof TaxonomyJobProfileSchema>;

export const TaxonomySchema = z.object({
  businessTitles: z.record(z.string(), TaxonomyBusinessTitleSchema),
  generalSkills: z.record(z.string(), TaxonomyGeneralSkillSchema),
  industries: z.record(z.string(), TaxonomyIndustrySchema),
  jobProfiles: z.record(z.string(), TaxonomyJobProfileSchema),
  legalSkills: z.record(z.string(), TaxonomyLegalSkillSchema),
  legalTechSkillCategories: z.record(
    z.string(),
    TaxonomyLegalTechSkillCategorySchema
  ),
  legalTechSkills: z.record(z.string(), TaxonomyLegalTechSkillSchema),
  practiceAreas: z.record(z.string(), TaxonomyPracticeAreaSchema),
  focusAreas: z.record(z.string(), TaxonomyFocusAreaSchema),
  skillGroups: z.record(z.string(), TaxonomySkillGroupSchema),
  clientSubNavigationHeader: z.record(
    z.string(),
    TaxonomyClientSubNavigationHeaderSchema
  ),
});

export type Taxonomy = z.infer<typeof TaxonomySchema>;

export type TaxonomyJobProfileEnum = keyof Taxonomy['jobProfiles'];
export type TaxonomyBusinessTitleEnum = keyof Taxonomy['businessTitles'];
export type TaxonomyFocusAreaEnum = keyof Taxonomy['focusAreas'];
export type TaxonomyGeneralSkillEnum = keyof Taxonomy['generalSkills'];
export type TaxonomyIndustryEnum = keyof Taxonomy['industries'];
export type TaxonomyLegalSkillEnum = keyof Taxonomy['legalSkills'];
export type TaxonomyLegalTechSkillCategoryEnum =
  keyof Taxonomy['legalTechSkillCategories'];
export type TaxonomyLegalTechSkillEnum = keyof Taxonomy['legalTechSkills'];
export type TaxonomyPracticeAreaEnum = keyof Taxonomy['practiceAreas'];
export type TaxonomySkillGroupEnum = keyof Taxonomy['skillGroups'];
